import React, { Component } from "react";
// import $ from "jquery";
//import Apihelpers from "./helper/ApiHelper";
import { NEET_HELP_EMAIL } from "./helper/Constants";
// import { NavLink } from "react-router-dom";



class userDeleteSuccess extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="wrapper">
          <div className="container">
            <div className="flexWrapper">
              <div className="userDeletePage">
                <div className="popUpLogo">
                  <img src="/assets/images/logo.png" alt="" />
                </div>
                <div className="form">
                  <div className="form-group">
                    <h3>Request Account Deletion.</h3>
                    <div className="desc">Note : Account Deletion is Permanent.  By Proceeding ahead you will loose access to all our services and all your data will be deleted. </div>
                  </div>

                  <div className="thanksMesg">User Removed Successfully</div>

                </div>
                <div className="bottomBg">
                  Need help?  <a href={"mailto:" + NEET_HELP_EMAIL}>{NEET_HELP_EMAIL}</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default userDeleteSuccess;
